import React from 'react';

const Anchor = ({ to, children, ...props }) => (
  <a href={to} {...props}>
    {children}
  </a>
);

export default Anchor;
